(function (ws) {
    'use strict';

    ws.views.stackedRenewalsBarChart = ws.views.baseWidget.extend({
        GTM_EVENT_CATEGORY: 'store_dashboard',
        GTM_EVENT_ACTION: 'click_renewals_statistics_CTA',

        events: {
            'click .cta-link a': 'renewalsTrackCtaLinkOnBar',
            'mouseover .bars': 'changeUrl',
            'mouseover .red-widget': 'mouseHoverUrloverDue',
            'click .RangeTotal': 'doNotRedirect',
            'mouseover .RangeTotal': 'doNotRedirect'
        },

        /**
		 * Initializes the component.
		 */
        initialize() {
            ws.views.baseWidget.prototype.initialize.call(this);

            this.data = this.$('.renewals-meta-data').data('json');
            this.$stackedBarGraph = this.$('.stacked-renewals-bar');
            this.$stackedBarRange = this.$('.stacked-renewals-range');
            this.graphContentListValues = _.template($('#renewal-range-values').html());
            this.stackedGraphContentListValues = _.template($('#stacked-renewals-bar-graph-content').html());
            this.stackedGraphRangeContent = _.template($('#stacked-renewals-bar-graph-range-content').html());
            this.render();
        },

        /**
		 * Renders the component based on the json data provided by the backend.
		 * Normalizes each data point for conversion into a CSS height for each
		 * bar.
		 */
        render() {
            var strGraphContent = '';
            var strLegendContent = '';
            var strRangeContent = '';
            var maxrange = [];
            for (var k = 0; k < this.data.length; k++) {
                maxrange.push(this.data[k].renewalOpportunities);
            }

            var maxRange = Math.max.apply(null, maxrange);
            for (var i = 0; i < this.data.length; i++) {
                var graphContentList = '';
                var expPeriodWithAmtRangeBarFromDate;
                var expPeriodWithAmtRangeBarToDate;
                var rangetotal = this.data[i].renewalOpportunities;
                var amountRangeVal = this.data[i].amountRange;
                var keysRenewal = Object.keys(this.data[i].expPeriodWithAmtRange);
                var expPeriodWithAmtRange = this.data[i].expPeriodWithAmtRange.overDueRange;
                var stackedRange = this.data[i].amountRange;

                this.data[i].expPeriod.pop();
                for (var j = 0; j < this.data[i].expPeriod.length; j++) {
                    var width = (this.data[i].expPeriod[j] * 80) / maxRange;
                    if (isNaN(width)) { width = 0;}

                    if (j == 0) {
                        expPeriodWithAmtRangeBarFromDate = 0;
                        expPeriodWithAmtRangeBarToDate = keysRenewal[j];
                    } else {
                        expPeriodWithAmtRangeBarFromDate = keysRenewal[j - 1];
                        expPeriodWithAmtRangeBarToDate = keysRenewal[j];
                    }

                    graphContentList += this.graphContentListValues({rangetotal:rangetotal, amountRange:amountRangeVal, expPeriodWithAmtRangeBarFromDate:expPeriodWithAmtRangeBarFromDate, expPeriodWithAmtRangeBarToDate:expPeriodWithAmtRangeBarToDate, data:width});
                }

                strGraphContent += this.stackedGraphContentListValues({graphContentList:graphContentList, rangetotal:rangetotal});
                strRangeContent += this.stackedGraphRangeContent({stackedRange:stackedRange, amountRange:amountRangeVal, overDueRange:expPeriodWithAmtRange});
            }

            this.$stackedBarGraph.html(strGraphContent);
            this.$stackedBarRange.html(strRangeContent);
        },

        /**
		 * Sends data from a link to Google Analytics;
		 *
		 * @param {Event}
		 *            e
		 */
        renewalsTrackCtaLinkOnBar: function(e) {
            // Stop the link from navigating away
            e.preventDefault();

            // Send tracking data to Google Analytics
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION, 'cta_button');

            // Send tracking data to adobe Analytics
            dataLayerAA.event = {};
            dataLayerAA.event.action = 'view renewals opportunities';
            dataLayerAA.event.label = e.target.text.toLowerCase();
            _satellite.track('event:dashboard');

            // Navigate away after the tracking is complete
            window.location.href = $(e.currentTarget).attr('href');
        },

        /**
         * Updating the anchor link on hover of the bars on renewal widget;
         *
         * @param {Event} e
         *
         */
        changeUrl: function (e) {
            e.preventDefault();
            var hrefUrl = $(e.currentTarget).parent().parent();
            hrefUrl.css('cursor', 'pointer');
            var renewalsDateRangeFromDate = '&renewalsFromDate=' + $(e.currentTarget).data('experiodfromdate');
            var renewalsDateRangeToDate = '&renewalsToDate=' + $(e.currentTarget).data('experiodtodate');
            var amountRangeValue = $(e.currentTarget).data('amountrange');
            $(hrefUrl).attr('href', $(hrefUrl).data('hrefurl') + renewalsDateRangeFromDate + renewalsDateRangeToDate + this.updateUrlRenewalBars(amountRangeValue));
        },

        /**
         * Updating the anchor link on hover of the overdue red bar on renewal widget;
         *
         * @param {Event}  e
         *
         */
        mouseHoverUrloverDue: function (e) {
            e.preventDefault();
            var hrefUrl = $(e.currentTarget).parent();
            var parentHrefUrl = $(e.currentTarget).parent().data('hrefUrl');
            var amountRangeValue = $(e.currentTarget).data('amountrange');
            $(hrefUrl).attr('href', $(hrefUrl).data('hrefurl') + this.updateUrlRenewalBars(amountRangeValue));
        },

        /**
         * updating the url on mouse of bars
         *
         * @param {amountRangeValue} amountRangeValue
         *
         */

        updateUrlRenewalBars: function (amountRangeValue) {
            var priceRange = amountRangeValue.split(/>|<|-/);

            if (priceRange[0] == '') {
                priceRange[0] = '0';
                priceRange[1] = priceRange[1].slice(0, -1) + '000';
            } else {
                priceRange[0] = priceRange[0] + '000';
                priceRange[1] = priceRange[1].slice(0, -1) + '000';
            }

            if (amountRangeValue == '>250K') {
                priceRange[0] = priceRange[1];
                priceRange[1] = '';
            }

            let amountRange = '&lowPrice=' + priceRange[0] + '&highPrice=' + priceRange[1];
            return amountRange;
        },

        /**
         * Function to restrict the redirection on click of Range Total Value
         * params: {e} Event
         **/
        doNotRedirect: function (e) {
            $(e.currentTarget).parent().parent().css('cursor', 'default');
            e.preventDefault();
        }

    });
})(westcon);
